import { useEffect, useState } from 'react';
import trainingPhotos from '../data/trainingGallery';
import useAnimated from '../hooks/useAnimated';

function Gallery() {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useAnimated('.gallery-card');

  useEffect(() => {
    if (!selectedPhoto) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setSelectedPhoto(null);
    };

    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [selectedPhoto]);

  const photoUrl = (filename) =>
    `${process.env.PUBLIC_URL}/training-gallery/${filename}`;

  return (
    <section className="gallery" id="gallery">
      <div className="container">
        <div className="section-title">
          <span className="eyebrow">Moments that inspire</span>
          <h2>School Visits &amp; Training Gallery</h2>
          <p>
            A glimpse into our hands-on workshops, school visits and joyful
            learning sessions with students and educators.
          </p>
        </div>

        {trainingPhotos.length > 0 ? (
          <div className="gallery-grid">
            {trainingPhotos.map((photo) => (
              <button
                className="gallery-card"
                type="button"
                key={photo.src}
                onClick={() => setSelectedPhoto(photo)}
                aria-label={`View ${photo.title}`}
              >
                <img src={photoUrl(photo.src)} alt={photo.alt} loading="lazy" />
                <span className="gallery-overlay">
                  <strong>{photo.title}</strong>
                  {photo.location && <small>{photo.location}</small>}
                </span>
              </button>
            ))}
          </div>
        ) : (
          <div className="gallery-empty">
            <span className="gallery-empty-icon" aria-hidden="true">▧</span>
            <h3>Training moments coming soon</h3>
            <p>Photos from our school visits and training sessions will be shared here.</p>
          </div>
        )}
      </div>

      {selectedPhoto && (
        <div
          className="gallery-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={selectedPhoto.title}
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) setSelectedPhoto(null);
          }}
        >
          <button
            className="gallery-lightbox-close"
            type="button"
            onClick={() => setSelectedPhoto(null)}
            aria-label="Close photo"
          >
            ×
          </button>
          <figure>
            <img src={photoUrl(selectedPhoto.src)} alt={selectedPhoto.alt} />
            <figcaption>
              <strong>{selectedPhoto.title}</strong>
              {selectedPhoto.location && <span>{selectedPhoto.location}</span>}
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
}

export default Gallery;
